import { render, staticRenderFns } from "./rfq.vue?vue&type=template&id=6cffd17f&"
import script from "./rfq.vue?vue&type=script&lang=js&"
export * from "./rfq.vue?vue&type=script&lang=js&"
import style0 from "./rfq.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports